module.exports = new __parcel__URL__("tshirt_blue.6d8c82b9.jpg").toString();